<ion-header>
  <ion-toolbar>
    <ion-title
      >{{ "upload.documentsTo" | translate }}
      {{ this.currentFolder?.displayName }} hochladen</ion-title
    >
    <ion-buttons slot="end">
      <ion-button (click)="close()" [disabled]="uploadIsRunning">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content #modalContent>
  <div class="upload-section">
    @if(uploadIsRunning){
    <b
      >{{ "upload.running" | translate }}: {{ this.uploadCounter }} /
      {{ files.length }} hochgeladen</b
    >
    }@else if (failedUploads.length > 0){
    <div class="red">
      {{ "upload.failed" | translate : { count: files.length } }}
    </div>
    }@else{
    <div>
      <span>{{
        "upload.selected" | translate : { count: files?.length }
      }}</span>
      @if(invalidFileInfos?.length > 0){<span
        >, {{ invalidFileInfos?.length }}
        {{ "common.errors" | translate }}:</span
      >}
    </div>
    } @for (info of invalidFileInfos; track info) {
    <div class="errors red">
      {{ info }}
    </div>
    } @for (item of files; track item; let i = $index) {
    <div class="file-view">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        mode="md"
        [(ngModel)]="item.displayName"
        [clearInput]="true"
      >
        <!--div slot="label">Dateiname</div-->
        @if (item.file != null) {
        <div slot="label">
          {{ tools.getDateString(item.file.lastModified) }} /
          {{ getFileSize(item.file.size) }} KB / {{ item.fileType }}
        </div>
        } @if (item.blob != null) {
        <div slot="label">
          {{ tools.getDateString(null) }} / {{ getFileSize(item.blob.size) }} KB
          /
          {{ item.fileType }}
        </div>
        }
      </ion-input>
      <ion-icon
        (click)="removeFile(i)"
        size="large"
        class="red"
        style="margin-left: 20px"
        name="trash-outline"
      ></ion-icon>
    </div>
    }
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button (click)="startUpload()" expand="block"
      ><ion-icon
        name="cloud-upload-outline"
        slot="start"
        class="white"
      ></ion-icon
      >{{ "common.uploadDocuments" | translate }}</ion-button
    >
  </ion-toolbar>
</ion-footer>
